export default "__VITE_ASSET__Ch0eIDF6__"